import { render, staticRenderFns } from "./listAdd.vue?vue&type=template&id=4a706068&scoped=true&"
import script from "./listAdd.vue?vue&type=script&lang=js&"
export * from "./listAdd.vue?vue&type=script&lang=js&"
import style0 from "./listAdd.vue?vue&type=style&index=0&id=4a706068&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a706068",
  null
  
)

export default component.exports